//import packageInfo from '../../../../package.json';

/*
* Denne filen definerer prod-spesifikke verdier for bruk i kode.
* Denne filen er knyttet til '--configuration production' bryteren i angular cli.
*
* Se 'miljø.<configuration>.ts for definisjoner for andre miljøer enn production.
* Se også oppsett av 'fileReplacements' i angular.json
*/
import {ByggmiljøNg2} from "web-ng2/miljø/ByggmiljøNg2";

export const byggmiljøNg2:ByggmiljøNg2 = {
  production: true,
  //version: packageInfo.version, //per nå setter ikke bygget versjonsnummer i package.json
};
